import React, { useRef, useState, useEffect } from 'react';

const AudioRecorder = ({ onRecordingComplete, onStart, onStop, maxDuration = 5, disabled }) => {
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const timerRef = useRef(null);
  const mimeTypeRef = useRef(''); // Track the actual mime type used

  const startRecording = async () => {
    setAudioURL(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      let options = {};
      if (MediaRecorder.isTypeSupported('audio/mp4')) {
        options.mimeType = 'audio/mp4';
        mimeTypeRef.current = 'audio/mp4';
      } else if (MediaRecorder.isTypeSupported('audio/webm')) {
        options.mimeType = 'audio/webm';
        mimeTypeRef.current = 'audio/webm';
      } else {
        mimeTypeRef.current = '';
      }
      mediaRecorderRef.current = new window.MediaRecorder(stream, options);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = () => {
        setTimeout(() => {
          const audioBlob = new Blob(audioChunksRef.current, { type: mimeTypeRef.current });
          const url = URL.createObjectURL(audioBlob);
          setAudioURL(url);

          console.log('Blob type:', audioBlob.type, 'size:', audioBlob.size);

          if (onRecordingComplete) {
            onRecordingComplete(audioBlob, mimeTypeRef.current);
          }
          if (onStop) onStop();
        }, 100);
      };

      mediaRecorderRef.current.start();
      setRecording(true);

      if (onStart) onStart();

      timerRef.current = setTimeout(() => {
        stopRecording();
      }, maxDuration * 1000);
    } catch (err) {
      alert('Microphone access denied or not available.');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
      mediaRecorderRef.current.stop();
      setRecording(false);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <div className="audio-recorder">
      <button
        className={`btn ${recording ? 'btn-danger' : 'btn-primary'} me-2`}
        onClick={recording ? stopRecording : startRecording}
        disabled={disabled}
      >
        {recording ? 'Stop Recording' : 'Start Recording'}
      </button>
      {audioURL && (
        <audio controls src={audioURL} className="mt-2" />
      )}
    </div>
  );
};

export default AudioRecorder;